import React, { useState } from "react";
import { Tabs, Col } from "antd";
import ArtistMainLayout from "../ArtistMainLayout";
import ProductSearch from "../../AdminComponents/SearchItem/ProductSearch";
import SpaceSearch from "../../AdminComponents/SearchItem/SpaceSearch";
import MaterialSearch from "../../AdminComponents/SearchItem/MaterialSearch";
const { TabPane } = Tabs;

const ArtistSearchItem = () => {
    const [tabActiveKey, setTabActiveKey] = useState('product');
    const tabs = [
        {
          key: 'product',
          title: 'Product',
          Component: (() => {
            return (
            <ProductSearch>
            </ProductSearch>
            )
          })
        },
        {
          key: 'space',
          title: 'Space',
          Component: (() => {
            return (
            <SpaceSearch>
            </SpaceSearch>
            )
          })
        },
        {
          key: 'material',
          title: 'Material',
          Component: (() => {
            return (
            <MaterialSearch>
            </MaterialSearch>
            )
          })
        }
      ];
    const handleTabChange = (key) => {
        setTabActiveKey(key);
    };

    return (
        <ArtistMainLayout selected={'11'}>
            <Col span={24}>
                <Tabs
                onChange={(key) => handleTabChange(key)}
                tabBarGutter={16}
                size="large"
                className="product-tab library"
                activeKey={tabActiveKey}>
                    {
                        tabs?.map((tab) => {
                            return (
                                <TabPane tab={tab.title} key={tab.key} style={{ padding: "0px 10px" }}> 
                                {
                                    tab.Component()
                                }
                                </TabPane>
                            )
                        })
                    }  
                </Tabs>
            </Col>
        </ArtistMainLayout>
    )
}

export default ArtistSearchItem;